import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-videoIcon",
  "use": "icon-videoIcon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-videoIcon\"><defs><style type=\"text/css\"></style></defs><path d=\"M806.2 64H217.3C133 64 64 133 64 217.3v588.8c0 84.3 69 153.3 153.3 153.3h588.8c84.3 0 153.3-69 153.3-153.3V217.3C959.5 133 890.5 64 806.2 64zM710 566.3L466.2 707c-42 24.2-94.4-6.1-94.4-54.5V371c0-48.5 52.5-78.7 94.4-54.5L710 457.2c41.9 24.3 41.9 84.8 0 109.1z\" fill=\"#8a8a8a\" p-id=\"587\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/videoIcon.svg
// module id = UoH+
// module chunks = 138